import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

export type ModalAction = 'approve' | 'reject' | 'info';

export interface ModalResult {
  action: ModalAction;
  message: string;
}

@Component({
    selector: 'app-approve-reject-modal',
    templateUrl: './approve-reject-modal.component.html'
})
export class ApproveRejectModalComponent {
    @Input() action: ModalAction = 'approve';
    @Input() expenseLabel = '';
    @Output() confirmed = new EventEmitter<ModalResult>();
    @Output() cancelled = new EventEmitter<void>();

    messageControl = new FormControl('', [Validators.minLength(10)]);

    get title(): string {
        const map: Record<ModalAction, string> = {
            approve: 'Aprobar gasto',
            reject: 'Rechazar gasto',
            info: 'Solicitar información'
        };
        return map[this.action];
    }

    get placeholder(): string {
        const map: Record<ModalAction, string> = {
            approve: 'Comentario opcional (mín. 10 caracteres)...',
            reject: 'Motivo del rechazo (obligatorio, mín. 10 caracteres)...',
            info: 'Información que se solicita (mín. 10 caracteres)...'
        };
        return map[this.action];
    }

    get confirmClass(): string {
        const map: Record<ModalAction, string> = {
            approve: 'btn-success',
            reject: 'btn-danger',
            info: 'btn-warning'
        };
        return map[this.action];
    }

    get messageRequired(): boolean {
        return this.action === 'reject' || this.action === 'info';
    }

    isValid(): boolean {
        const val = this.messageControl.value || '';
        if (this.messageRequired) return val.length >= 10;
        return true;
    }

    confirm(): void {
        if (!this.isValid()) {
            this.messageControl.markAsTouched();
            return;
        }
        this.confirmed.emit({ action: this.action, message: this.messageControl.value || '' });
        this.messageControl.reset();
    }

    cancel(): void {
        this.messageControl.reset();
        this.cancelled.emit();
    }
}
